

import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import EditbleTable ,{EditableTableProps}from "../editble-table";
import { Save } from '@mui/icons-material';
import { ErrorMark, MySuccessMark } from '../Loader/Loader';
import { useState } from 'react';
import { useTranslation } from 'react-multi-lang';
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface iOptions {
    [key: string]: any;
  }
  
  interface iTouched {
    [key: string]: any;
  }
interface iProps  extends EditableTableProps{open:boolean ,setOpen:Function ,
  saveUpdate:()=>boolean
}

export default function EditALlTable({open,setOpen,error,handleChange,headers
,touched,values,addLine,handleBlur,options,removeLine,selectInput,lines_number,maxHeight,
saveUpdate}:iProps) {
  const [isSucceed,setIsSucceed]=useState(false)
  const[isFailed,setIsFailed]=useState(false)
  const t=useTranslation()

  const handleSave = () => {
   let result= saveUpdate()
   if (result){
    setIsSucceed(result)
    handleClose()
   }
   else {
    setIsFailed(result)
   }
    
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <MySuccessMark succeed={isSucceed} setSucceed={setIsSucceed} />
      <ErrorMark failed={isFailed} setFailed={setIsFailed} />
      
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        
       
      >
        <AppBar sx={{ position: 'relative' ,background:"var(--primary-color)"}}
       >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
           <Button></Button>
            <Button autoFocus color="inherit" onClick={handleSave}
            style={{border:'1px solid white'}}>
              <span>{t("save")}</span>
              <Save style={{color:'white',marginInline:'6px'}} />
            </Button>
          </Toolbar>
        </AppBar>
        <List sx={{paddingBlock:'20px'}}>
         <EditbleTable 
         error={error}  
         handleChange={handleChange}
         handleBlur={handleBlur}
         headers={headers} touched={touched} values={values} removeLine={removeLine}
         lines_number={lines_number} maxHeight={maxHeight}
         array_name='dummy'
         />
        </List>
      </Dialog>
    </React.Fragment>
  );
}